/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":"html,body{-webkit-tap-highlight-color:transparent}\n"}]);